/** The board's period: a calendar month, carried in the URL as `YYYY-MM`. */
import { nowPlainDate, Temporal } from '@insio/dates';

/** How many months back the period selector offers, including the current one. */
export const BOARD_MONTH_OPTIONS = 12;

const MONTH_PATTERN = /^\d{4}-\d{2}$/;

/** The month the board defaults to — the running one. */
export function currentBoardMonth(): Temporal.PlainYearMonth {
  return nowPlainDate().toPlainYearMonth();
}

/** Reads `YYYY-MM` from the URL; anything else degrades to "no month in the URL". */
export function parseBoardMonth(value: string | null): Temporal.PlainYearMonth | null {
  if (!value || !MONTH_PATTERN.test(value)) return null;
  try {
    return Temporal.PlainYearMonth.from(value);
  } catch {
    return null;
  }
}

/** The `MasterAccountBoardPeriodInput` a month stands for — both days inclusive. */
export function boardMonthToPeriod(month: Temporal.PlainYearMonth): {
  from: Temporal.PlainDate;
  to: Temporal.PlainDate;
} {
  const from = month.toPlainDate({ day: 1 });
  return { from, to: from.with({ day: month.daysInMonth }) };
}

/** The selectable months, newest first, ending with the current one. */
export function recentBoardMonths(
  count: number = BOARD_MONTH_OPTIONS,
  anchor: Temporal.PlainYearMonth = currentBoardMonth()
): Temporal.PlainYearMonth[] {
  return Array.from({ length: count }, (_, index) => anchor.subtract({ months: index }));
}
